import PropTypes from "prop-types";
import { useMatchMedia } from "../../hooks";
import styles from "./index.css";

const FeaturedCategoryHeaderTitleOverlay = ({
  headerTitle,
  headerDisplayText,
  scrollFunction
}) => {
  const prefersReducedMotion = useMatchMedia("(prefers-reduced-motion)");

  return (
    <div className={styles.titleOverlay}>
      <h1 className={styles.headerTitle}>{headerTitle}</h1>
      <button className={styles.scrollToButton} onClick={scrollFunction}>
        <span className={styles.scrollToText}>{headerDisplayText}</span>
        <span
          className={!prefersReducedMotion ? styles.scrollToIcon : undefined}
        />
      </button>
    </div>
  );
};

FeaturedCategoryHeaderTitleOverlay.propTypes = {
  headerTitle: PropTypes.string.isRequired,
  headerDisplayText: PropTypes.string.isRequired,
  scrollFunction: PropTypes.func.isRequired
};

export default FeaturedCategoryHeaderTitleOverlay;
